$('body').on('click', '.js-toggle-intro-content', function (e){
  e.preventDefault()
  $('.intro-preview').toggleClass('is-opened')
})
